export var BackupZeroEtlRoutingMode;
(function (BackupZeroEtlRoutingMode) {
    BackupZeroEtlRoutingMode["BACKUP_ZERO_ETL_ROUTING_MODE_FULLY_QUALIFIED"] = "FULLY_QUALIFIED";
    BackupZeroEtlRoutingMode["BACKUP_ZERO_ETL_ROUTING_MODE_MANUAL"] = "MANUAL";
})(BackupZeroEtlRoutingMode || (BackupZeroEtlRoutingMode = {}));
